/**
 * en-US is deliberate: it renders all three symbols cleanly (£1, $1, €1),
 * whereas en-GB writes USD as "US$1".
 */
export function formatAmount(amount: number, currency: string) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
    minimumFractionDigits: amount % 100 === 0 ? 0 : 2,
  }).format(amount / 100);
}
